/**
 * Portfolio-oriented starter prompts (easy to edit).
 * Used by the home chat prototype — not factual knowledge.
 */
export const STARTER_PROMPTS = [
  {
    id: 'builds',
    label: 'What have you built?',
  },
  {
    id: 'best',
    label: 'Show me your best work.',
  },
  {
    id: 'ai',
    label: 'What have you done with AI?',
  },
  {
    id: 'connect',
    label: 'How do research and products connect?',
  },
];

export default STARTER_PROMPTS;
